<template>
  <div class="container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
            <!-- {{jsondata}} -->
          <div class="col-md-8 offset-md-2">
            <h5 class="card-title text-center">Devolución de cliente</h5>
            <h6 class="card-title text-center mb-3">No. cliente: <span style="color: green;"><b>{{data.key_client}}</b></span></h6>
            <div class="row mt-4 justify-content-center">
                <p><b>{{data.fullname}}</b></p>
            </div>
            <div class="row justify-content-center">
              <h4><b>Folio # {{ nextDevolution }}</b></h4>
            </div>
            <div class="row justify-content-center">
              <h5><b>Cantidad de Productos: <span style="color: blue;">{{ jsondata.length }}</span>
            </b></h5>
              <h5><b>Total Devolución: <span style="color: red;">$ {{ totalDevolucion | formatNumberCurrency }}</span></b></h5>
            </div>
            <div class="row mt-3 justify-content-center">
                 <div class="card">
                    <div class="card-body text-center">
                        <input ref="searchBarcode" class="inputBarCode" type="number" v-model="barcodeSearch" placeholder="Codigo de barras" v-on:keyup.enter="searchItem" min="0"/>
                    </div>
                </div>
            </div>
            <div class="row mt-4 justify-content-center">
                <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="jsondata"
                :row-style-class="rowStyleClassFn"
                :totalRows="jsondata.length"
                :sort-options="{
                    enabled: true,
                    initialSortBy: [{field: 'name', type: 'asc'}]
                }"
                :isLoading.sync="isLoading"
                styleClass="vgt-table bordered"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'actions'" class="text-center" style="text-align: center;">
                  <!-- {{jsondata[props.index]}} -->
                  <button class="btn" style="background: red; color: white; font-size: 10px;" @click="cancelar(props)" >Cancelar</button>
                </span>
              </template>
            </vue-good-table>
            </div>
            <div class="row mt-5 justify-content-center">
                <div class="col-lg-4 text-center">
                    <button class="btn btn-purple" :disabled="jsondata.length === 0 || disabled" @click="devolver">Realizar devolución</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          filename = "hehehe.pdf"
          :paginate-elements-by-height="300"
          :pdf-quality="2"
          :manual-pagination="true"
          :htmlToPdfOptions = "htmlToPdfOptions"
          pdf-format="b6"
          pdf-orientation="portrait"
          @progress="onProgress($event)"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          @beforeDownload="beforeDownload($event)"
          ref="html2Pdf"
        >
          <section slot="pdf-content" style="width: 75mm !important;">
            <div class="container ticket" style="width: 75mm !important">
              <div class="row mt-5 justify-content-center">
                <div class="col-lg-11 text-center line1">
                  <p>Mundo del catalogo</p>
                  <p>{{enterpriseData.name}}</p>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-lg-10 mt-1 text-center line1">
                  <p>Nota de Devolución</p>
                  <p>FOLIO: {{ lastFolio }}</p>
                </div>
              </div>
              <div class="row justify-content-center" style="width: 75mm !important;">
                <div class="col-lg-10 text-center">
                <VueBarcode :value="itemDevolution.barcode" format="CODE39"  textPosition="top" :options="barcode_option" height="40" width="1" font-size="8"/>
                </div>
              </div>
              <div class="mt-4 bodyPrintAbono line1">
                <p><b>Cliente: {{ itemDevolution.client_id }}
                  <br>
                  {{itemDevolution.client}}</b></p>
                <p><b>Total de Productos: {{ lastDevolutions.length }}</b></p>
                <div class="row justify-content-center mt-4 bodyPrintAbono line1" style="width: 70mm !important;">
              <div class="col-lg-12">
                <table style="border: .5px solid #999; padding: 0px;" class="bodyLineHeigth line1">
                  <tr class="text-center tableXD">
                    <td style="height: 5px;">Codigo<br />Descripción</td>
                    <td>SubTotal.</td>
                    <td>Desc.</td>
                    <td>Total</td>
                  </tr>
                  <tr class="text-right" v-for="(v, index) in lastDevolutions" :key="index" style="font-size: 7px;">
                    <td class="line1 line2" style="font-size: 8px;"><b>
                      {{v.bar}}<br/>{{v.producto}}
                    </b>
                  </td>
                  <td class="line1 line2" style="font-size: 8px;"><b>
                   $ {{v.precio | formatNumberCurrency}}
                  </b>
                  </td>
                  <td class="line1 line2 text-center" style="font-size: 8px;"><b></b>
                    {{v.porcentaje_descuento}} %
                  </td>
                  <td class="line1 line2" style="font-size: 8px;"><b>
                    $ {{v.venta | formatNumberCurrency}}
                  </b>
                  </td>
                  </tr>
                </table>
              </div>
            </div>
                <div class="mt-4 text-center">
                  Total Vale: <b>$ {{itemDevolution.venta | formatNumberCurrency}}</b>
                </div>
              </div>
              <div class="row justify-content-center mt-2">
                <p class="mr-3"><b>FECHA DE EXPEDICIÓN: {{ itemDevolution.create_at }}</b></p>
              </div>
              <div class="row justify-content-center mt-2">
                <div class="col-lg-10 text-center footerTicket">
                  <p>Gracias por su preferencia</p>
                  <p>Teléfonos</p>
                  <p v-for="(p, index) in footer.phones" :key="index">{{p.phone}}</p>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-lg-10">
                  <p>Valido durante 45 días despues de la fecha de expedición.</p>
                </div>
              </div>
            </div>
          </section>
        </vue-html2pdf>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import { validationMixin } from 'vuelidate'
// import { required } from 'vuelidate/lib/validators'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'
import VueBarcode from 'vue-barcode'
import VueHtml2pdf from 'vue-html2pdf'
import moment from 'moment-timezone'

// import {
//   BForm,
//   BButton,
//   BFormGroup,
//   BFormInput,
//   // BFormSelect,
//   BFormInvalidFeedback
// } from 'bootstrap-vue'

export default {
  mixins: [validationMixin, formatData],
  props: ['clienteProp', 'printFolio'],
  components: {
    VueHtml2pdf,
    VueBarcode
  },
  data () {
    return {
      disabled: false,
      footer: {
        phones: [],
        texto: ''
      },
      lastDevolutions: [],
      lastFolio: 0,
      nextDevolution: 0,
      barcode_option: {
        format: 'EAN13',
        lineColor: '#0aa',
        height: 55
      },
      itemDevolution: {
        venta: 0,
        client: ''
      },
      htmlToPdfOptions: {
        margin: 0,
        // margin: 0,
        // image: {
        //   type: 'jpeg',
        //   quality: 0.98
        // },
        // enableLinks: false,
        html2canvas: {
          scale: 3,
          useCORS: true
        }
        // jsPDF: {
        //   unit: 'mm',
        //   format: 'b10',
        //   orientation: 'portrait'
        // }
      },
      data: [],
      nextClient: 0,
      totalDevolucion: 0,
      isLoading: false,
      barcodeSearch: '',
      jsondata: [],
      enterpriseData: [],
      columns: [
        {
          label: 'Codigo',
          field: 'barcode'
        },
        {
          label: 'Proveedor',
          field: 'providerName'
        },
        {
          label: 'Modelo',
          field: 'modelo'
        },
        {
          label: 'Color',
          field: 'color'
        },
        {
          label: 'Talla',
          field: 'numero'
        },
        {
          label: 'Cantidad',
          field: 'cantidad'
        },
        {
          label: 'Total',
          field: 'venta'
        },
        {
          label: 'Cancelar',
          field: 'actions'
        }
      ]
    }
  },
  methods: {
    async getCurrentEnterprise () {
      try {
        const request = {
          data: this.user.enterprise_id
        }
        const orders = await axiosAdelaService.post('/getEnterprisesSelected', request)
        console.log('getEnterprisesSelected', orders)
        if (orders.status === 200) {
          this.enterpriseData = orders.data.rows[0]
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    },
    rowStyleClassFn (row) {
      let color = ''
      if (row.encontrado === 1) {
        color = 'green'
      }
      if (row.otherClient === 1) {
        color = 'otherClient'
      }
      return color
    },
    startPagination () {
      console.log('PDF has started pagination')
    },
    hasPaginated () {
      console.log('PDF has been paginated')
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      console.log('On Before PDF Generation')
    },
    onProgress (progress) {
      this.progress = progress
      console.log(`PDF generation progress: ${progress}%`)
    },
    async devolver () {
      console.log('realizar devolucion')
      const request = {
        key: this.data.key_client,
        enterprise_id: this.user.enterprise_id,
        user_id: this.user.user_admin_id,
        data: this.jsondata
      }
      console.log('request', request)
      const response = await axiosAdelaService.post('/addDevolutionClient', request)
      console.log('addDevolutionClient ', response)
      if (response.status === 200) {
        if (response.data.affectedRows > 0) {
          console.log('jsondata', this.jsondata)
          await this.getLastDevolutionClient()
        }
      }
    //   this.data = response.data
    },
    cancelar (props) {
      console.log(props)
      const temp = []
      for (const key in this.jsondata) {
        if (parseInt(key) !== parseInt(props.index)) {
          console.log('key !== props.index', parseInt(key) !== parseInt(props.index), key, props.index)
          temp.push(this.jsondata[key])
        }
      }
      this.jsondata = temp
    },
    async getClient () {
      const request = {
        key: this.data.key_client,
        id_empresa: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/searchClients', request)
      // console.log('searchClients ', response)
      this.data = response.data
    },
    async searchItem () {
      const barcode = this.barcodeSearch
      const request = {
        code: barcode,
        id_empresa: this.user.enterprise_id,
        key_client: this.data.key_client
      }
      console.log('request', request)
      const response = await axiosAdelaService.post('/searchOrder', request)
      console.log('searchClients ', response)
      if (response.status === 200) {
        if (response.data.error) {
          this.$toastedPush({
            message: response.data.msg,
            type: 'error'
          })
        } else {
          const x = this.jsondata.find(el => el.barcode === barcode)
          console.log('Lomencontro', x)
          if (x === undefined) {
            const today = moment()
            const diffRegisterDate = today.diff(moment(response.data.rows.update_at, 'YYYY-MM-DD'), 'days')
            console.log('dias de diferencia', diffRegisterDate)
            if (diffRegisterDate > 21) {
              this.$toastedPush({
                message: 'ESTE PRODUCTO CUENTA CON MAS DE 21 DIAS, NO PUEDE SER DEVUELTO',
                type: 'error'
              })
              this.$dialog.confirm(`
                <div class="row justify-content-center">
                  <div class="col-lg-10 text-center">
                    <h4 style="color:red"><b>El producto, cuenta con mas de 21 dias desde la venta, confirme que desea realizar la devolución del producto.</b></h4>
                  </div>
                </div>
              `)
                .then(async () => {
                  // console.log(this.jsondata[prop.index])
                  console.log('si lo queire')
                  this.jsondata.push(response.data.rows)
                  this.totalDevolucion += response.data.rows.venta
                })
                .catch((err) => {
                  console.log('presiono cancelar confirmationDialog', err)
                })
              return
            }
            this.jsondata.push(response.data.rows)
            this.totalDevolucion += response.data.rows.venta
          } else {
            this.$toastedPush({
              message: 'Este producto ya se encuentra en la lista de Devolución.',
              type: 'error'
            })
          }
        }
      }
      //   this.jsondata = a
      this.barcodeSearch = ''
    },
    async getLastDevolutionClient () {
      try {
        const request = {
          id_empresa: this.user.enterprise_id,
          key_client: this.data.key_client
        }
        console.log('request', request)
        const response = await axiosAdelaService.post('/getLastDevolutionClient', request)
        console.log('getLastDevolutionClient ', response)
        let totalVenta = 0
        if (response.status === 200) {
          console.log('Entro a el status')
          this.lastDevolutions = response.data.rows
          this.lastFolio = response.data.folio
          response.data.rows.forEach(el => {
            totalVenta += el.venta
          })
          this.itemDevolution.venta = totalVenta
          this.itemDevolution.create_at = response.data.rows[0].create_at
          this.itemDevolution.client = response.data.rows[0].fullName
          this.itemDevolution.barcode = response.data.rows[0].barcode
          this.itemDevolution.client_id = response.data.rows[0].client_id
          this.$refs.html2Pdf.generatePdf()
          this.disabled = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getDevolutionClient (val) {
      try {
        const request = {
          id_empresa: this.user.enterprise_id,
          folio: val
        }
        console.log('request', request)
        const response = await axiosAdelaService.post('/getDetailDevolutionTicket', request)
        console.log('getDetailDevolutionTicket ', response)
        // let totalVenta = 0
        // if (response.status === 200) {
        //   console.log('Entro a el status')
        //   this.lastDevolutions = response.data.rows
        //   response.data.rows.forEach(el => {
        //     totalVenta += el.venta
        //   })
        //   this.itemDevolution.venta = totalVenta
        //   this.itemDevolution.client = response.data.rows[0].fullName
        //   this.itemDevolution.barcode = response.data.rows[0].barcode
        //   this.$refs.html2Pdf.generatePdf()
        // }
      } catch (error) {
        console.log(error)
      }
    },
    async getNextDevolutionClient () {
      const items = {
        enterpriseId: this.user.enterprise_id
      }
      console.log('items', items)
      const response = await axiosAdelaService.post('/getNextDevolutionClient', items)
      if (response.status === 200) {
        this.nextDevolution = response.data.next
      }
    },
    async getFooterTicket () {
      try {
        const request = {
          enterprise_id: this.user.enterprise_id
        }
        const footer = await axiosAdelaService.post('/getFooterTicket', request)
        if (footer.status === 200) {
          console.log('footer', footer)
          this.footer.phones = footer.data.phones
          this.footer.texto = footer.data.textoFooter
        }
      } catch (error) {
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    }
  },
  watch: {
    // async barcodeSearch (value) {
    //   // console.log('entro a este watch', value)
    //   if (value !== '') {
    //     await this.searchItem(value)
    //   }
    // },
    printFolio () {
      alert('cambio el folioi a imorimir')
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  async mounted () {
    await this.getNextDevolutionClient()
    await this.getFooterTicket()
    console.log('Parametros desde devoluciones', this.$route.params)
    if (this.$route.params.key_client === undefined) {
      console.log('Esto esta vacio')
      this.data = this.clienteProp
    } else {
      this.data = this.$route.params
    }
    this.$refs.searchBarcode.focus()
    await this.getClient()
    // await this.getLastDevolutionClient()
  }
}
</script>

<style>
.inputBarCode {
  width: 300px;
  font-size: 20px;
  border-radius: 5px;
  border-color: blue;
  text-align: center;
}
.bodyPrintAbono table {
  font-family: 'Courier New', Courier, monospace;
  color: black;
  font-size: 8;
  width: 100%;
}

.bodyPrintAbono td, th {
  /* border: 1px solid #dddddd; */
  text-align: left;
  padding: 8px;
}

.bodyPrintAbono tr:nth-child(even) {
  /* background-color: #dddddd; */
}
.este {
  height: 5em;
  line-height: 1em;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
  border: 1px solid;
}
</style>
